export const getTraceIdFromResponse = (response: Response | undefined) =>
	response?.headers?.get('x-trace-id') ??
	response?.headers?.get('atl-traceid') ??
	response?.headers?.get('x-b3-traceid') ??
	undefined;

export interface RovoInstrumentedError extends Error {
	errorAttributes: {
		errorCode?: string;
		statusCode?: number;
		rawErrorMessage?: string;
		traceId?: string;
		requestId?: string;
		[key: string]: string | number | undefined;
	};
}

export class FetchError extends Error implements RovoInstrumentedError {
	constructor(
		message: string,
		public errorAttributes: {
			statusCode?: number;
			traceId?: string;
			requestId?: string;
			rawErrorMessage?: string;
			errorCode?: string;
		},
	) {
		super(message);
		this.name = 'FetchError';
	}
}

type FetchOptions = {
	path: string;
	options: RequestInit;
};

class HttpApiError extends Error implements RovoInstrumentedError {
	constructor(
		public message: string,
		public errorAttributes: {
			statusCode: number;
			traceId?: string;
			requestId?: string;
			rawErrorMessage?: string;
			errorCode?: string;
		},
	) {
		super(message);
	}
}

export const performHttpFetch = async ({ path, options }: FetchOptions) => {
	try {
		const response = await fetch(path, options);
		if (!response.ok || response.status >= 400) {
			await processHttpErrorResponse({ response });
		}
		return await response.json();
	} catch (err) {
		const originalErrorMessage =
			err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
		throw new FetchError(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
			errorCode: 'performHttpFetchError',
		});
	}
};

const processHttpErrorResponse = async ({
	response,
}: {
	response: Response;
}): Promise<Response> => {
	throw new HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
		statusCode: response.status,
		traceId: getTraceIdFromResponse(response),
	});
};
